import React from "react";

import { adminRoutes } from "./admin";
import { adminOperationsRoutes } from "./admin_operations";
import CustomerSignUpVerify from "pages/auth/signup-verify";
import CustomerSignUp from "pages/auth/signup";
import CustomerSignIn from "pages/auth/login";
import { customerRoutes } from "./customer";
import { fiancierRoutes } from "./finacier";
import { fiancierOpRoutes } from "./financier_operation";

import { partnerRoutes } from "./partner";
import ResetPassword from "pages/ResetPassword/resetPassword";
import Pages401 from "components/Common/pages-401";
import ForgotPassword from "pages/ResetPassword/ForgetPassword";
import MobileOtpVerify from "pages/auth/mobile-otp-verify";
import PartnerEnqueryForm from "pages/Partner/enquiry";
import { commonRoutes } from "./common_routes";
import MicrosoftLogin from "pages/auth/microsoft-login";
import LoadingPage from "pages/auth/validatelogin";

const adminSubmenu = (roleName)=> commonRoutes(roleName).filter((r) => r.hasOwnProperty("submenu"))?.map((menu) => menu.submenu).flat(1);

const customerSubmenu = customerRoutes.filter((r) => r.hasOwnProperty("submenu"))?.map((menu) => menu.submenu).flat(1);

const financierSubmenu = fiancierRoutes.filter((r) => r.hasOwnProperty("submenu"))?.map((menu) => menu.submenu).flat(1);

const partnerSubmenu = partnerRoutes.filter((r) => r.hasOwnProperty("submenu"))?.map((menu) => menu.submenu).flat(1);

const finacierOperationsSubmenu = fiancierOpRoutes.filter((r) => r.hasOwnProperty("submenu"))?.map((menu) => menu.submenu).flat(1);


const authProtectedRoutes=[
  ...customerRoutes,
  ...customerSubmenu,
  ...fiancierRoutes,
  ...financierSubmenu,
  ...partnerRoutes,
  ...partnerSubmenu,
  ...fiancierOpRoutes,
  ...finacierOperationsSubmenu
];

const authProtectedRoutesAdmin = (roleName)=> [
  ...commonRoutes(roleName),
  ...adminSubmenu(roleName),
]
const publicRoutes = [
  { "path": "/login", "component": <CustomerSignIn /> },
  { "path": "/inquiry", "component": <PartnerEnqueryForm /> },
  { "path": "/customer/register", "component": <CustomerSignUp /> },
  { "path": "/customer/register-otp-verify", "component": <CustomerSignUpVerify /> },
  { "path": "/reset-password", "component": <ResetPassword />, "hideMenu": true },
  { "path": "/forget-password", "component": <ForgotPassword />, "hideMenu": true },
  { "path": "/mobile-otp-verify", "component": <MobileOtpVerify /> },
  { "path": "/internal-login", "component": <MicrosoftLogin /> },
  { "path": "/validate-login", "component": <LoadingPage /> },
]

const commonFullPageRouters = [
  { "path": "/unauthorized", "component": <Pages401 /> },
]






export { authProtectedRoutes, publicRoutes, commonFullPageRouters, authProtectedRoutesAdmin };
